export default __webpack_public_path__ + "static/media/MightyMagnets_08.9d13fe81.png";